import { TemplateListItem } from '../VideoCreatorHelper/typings';

export const GET_VIDEO_CREATOR_TEMPLATE_LIST = 'GET_VIDEO_CREATOR_TEMPLATE_LIST';
export type GET_VIDEO_CREATOR_TEMPLATE_LIST = typeof GET_VIDEO_CREATOR_TEMPLATE_LIST;

export interface GetVideoCreatorAction {
    type: GET_VIDEO_CREATOR_TEMPLATE_LIST;
}

export function getVideoCreatorTemplateList(): GetVideoCreatorAction {
    return {
        type: GET_VIDEO_CREATOR_TEMPLATE_LIST
    };
}

export const SET_VIDEO_CREATOR_TEMPLATE_LIST = 'SET_VIDEO_CREATOR_TEMPLATE_LIST';
export type SET_VIDEO_CREATOR_TEMPLATE_LIST = typeof SET_VIDEO_CREATOR_TEMPLATE_LIST;

export interface SetVideoCreatorAction {
    type: SET_VIDEO_CREATOR_TEMPLATE_LIST;
    list: TemplateListItem[];
}

export function setVideoCreatorTemplateList(list: TemplateListItem[]): SetVideoCreatorAction {
    return {
        type: SET_VIDEO_CREATOR_TEMPLATE_LIST,
        list: list
    };
}

export const GO_TO_VIDEO_CREATOR_MY_LIST_PAGE = 'GO_TO_VIDEO_CREATOR_MY_LIST_PAGE';
export type GO_TO_VIDEO_CREATOR_MY_LIST_PAGE = typeof GO_TO_VIDEO_CREATOR_MY_LIST_PAGE;

export interface GoToVideoCreatorMyListPageAction {
    type: GO_TO_VIDEO_CREATOR_MY_LIST_PAGE;
}

export function goToVideoCreatorMyListPage(): GoToVideoCreatorMyListPageAction {
    return {
        type: GO_TO_VIDEO_CREATOR_MY_LIST_PAGE
    };
}

export const GO_TO_VIDEO_CREATOR_CREATE_PAGE = 'GO_TO_VIDEO_CREATOR_CREATE_PAGE';
export type GO_TO_VIDEO_CREATOR_CREATE_PAGE = typeof GO_TO_VIDEO_CREATOR_CREATE_PAGE;

export interface GoToVideoCreatorCreatePageAction {
    type: GO_TO_VIDEO_CREATOR_CREATE_PAGE;
    templateId: string;
}

export function goToVideoCreatorCreatePage(templateId: string): GoToVideoCreatorCreatePageAction {
    return {
        type: GO_TO_VIDEO_CREATOR_CREATE_PAGE,
        templateId
    };
}

export type VideoCreatorAction =
    | GetVideoCreatorAction
    | SetVideoCreatorAction
    | GoToVideoCreatorMyListPageAction
    | GoToVideoCreatorCreatePageAction;
